<template>
    <div class="mainContent">
        <div class="contentBox">
            <!--背景地图-->
            <div id="container" class="cen-top">
                <div class="saveButton" @click="saveMap"><i class="el-icon-collection"></i></div>
            </div>
            <!--顶部导航-->
<!--            <div class="banner">-->
<!--                <div class="timeClass">-->
<!--                    运行时长:{{ runTime }}-->
<!--                </div>-->
<!--                <div class="bannerTitle">{{ projectTitle }}</div>-->
<!--                <div class="menuClass">-->
<!--                    <div class="menuContent">-->
<!--                        <a class="menuItem" href="http://code.scentralit.com:60001">-->
<!--                            <img src="../assets/homeimg/link_icon.png" alt="">-->
<!--                            <span>采集仪</span>-->
<!--                        </a>-->
<!--                        <div class="menuItem">-->
<!--                            <img src="../assets/homeimg/name_icon.png" alt="">-->
<!--                            <span>{{ username }}</span>-->
<!--                        </div>-->
<!--                        <div class="menuItem" @click="logout">-->
<!--                            <img src="../assets/homeimg/loginout_icon.png" alt="">-->
<!--                            <span>退出</span>-->
<!--                        </div>-->
<!--                        <div class="menuItem">-->
<!--                            <img src="../assets/homeimg/about.png" alt="">-->
<!--                            <el-popover-->
<!--                                placement="bottom"-->
<!--                                width="350"-->
<!--                                trigger="click"-->
<!--                                popper-class="popover">-->
<!--                                <div class="popoverBox">-->
<!--                                    -->
<!--                                    <div class="popoverItem" v-for="(data1,index1) in systemAbout.descriptionArr"-->
<!--                                         :key="index1">-->
<!--                                        <span v-if="data1.type == 'text'">{{ data1.keyName }}</span>-->
<!--                                        <span v-if="data1.type == 'text'" @click="openUrl(data1.value)"-->
<!--                                              :style="{'cursor':isURL(data1.value) ? 'pointer' : 'default'}">-->
<!--                                            {{-->
<!--                                                data1.value-->
<!--                                            }}-->
<!--                                        </span>-->
<!--                                        -->
<!--                                        <img v-if="data1.type == 'images'" v-for="(data2,index2) in data1.images"-->
<!--                                             :key="index2"-->
<!--                                             @click="openPdf(data2.pdfUrl)" :src=data2.url alt="">-->
<!--                                    </div>-->
<!--                                    -->
<!--                                    <span> </span>-->
<!--                                    <span> </span>-->
<!--                                    <span> </span>-->
<!--                                    <span> </span>-->
<!--                                    -->
<!--                                    <div style="text-align: center;margin-top: 50px;margin-bottom:10px">-->
<!--                                        <img style="width: 150px;height: 28px"-->
<!--                                             :src="systemAbout.logoUrl"-->
<!--                                             alt="">-->
<!--                                    </div>-->
<!--                                    <div style="text-align: center">{{ systemAbout.bottomText }}</div>-->
<!--                                -->
<!--                                -->
<!--                                </div>-->
<!--                                <div class="aboutUs" slot="reference">关于我们</div>-->
<!--                            </el-popover>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
            <!--项目导航-->
            <div class="projectNav">
                <div class="titleName" @dblclick="setFoundation(item.id)"
                     v-for="(item,index) in navListTitle"><span>{{ item.name }}</span></div>
            </div>
            <!--左侧-->
            <div class="leftInfo">
                <div class="infoItem">
                    <div class="titleClass">
                        <div class="titleHead">
                            <div class="circulClass"></div>
                            <div class="subtitleClass">设备管理</div>
                        </div>
                        <div class="lineClass"></div>
                        <div class="lodingClasss"><img src="../assets/homeimg/titleloading.gif" alt=""></div>
                    </div>
                    <div class="equipContent">
                        <div class="number">
                            <div class="numberItem" @click="openDialog(1)">
                                <div class="numberItemBg"></div>
                                <div class="numberItemTitle">
                                  <span>{{ measureWork.stop }}</span>
                                  <span>离线设备</span>
                                </div>
                            </div>
                            <div class="numberItem">
                                <div class="numberItemBg"></div>
                                <div class="numberItemTitle">
                                  <span>{{ measureWork.work }}</span>
                                  <span>在线设备</span>
                                </div>
                            </div>
                            <div class="numberItem">
                                <div class="numberItemBg"></div>
                                <div class="numberItemTitle">
                                  <span>{{ measureWork.total }}</span>
                                  <span>设备总数</span>
                                </div>
                            </div>

                        </div>
                        <div class="echart">
                            <div id="equipEchart"></div>
                        </div>

                    </div>
                </div>
                <div class="infoItem" id="equipment">
                    <div class="titleClassNew">
                        <div class="titleClassNewContent">
                            <div class="circulClass"></div>
                            <div class="subtitleClass">设备统计</div>
                        </div>
                        <!--            下拉部分-->
                        <div>
                            <el-select v-model="projectName" placeholder="所有项目" value-key="id"
                                       @change="selectProNo">
                                <el-option v-for="item in projectList" :key="item.id" :label="item.name"
                                           :value="item"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <!--          内容部分-->
                    <div class="tableContent">
                        <el-table :data="tableList" style="width: 100%;" height="100%" @row-click="clickMonitorList">
                            <el-table-column align="center" prop="monitorObjName" label="设备名称"></el-table-column>
                            <el-table-column align="center" prop="count" label="设备数量"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <!--右侧-->
            <div class="rightInfo">
                <div class="infoItem">
                    <div class="titleClass">
                        <div class="titleHead">
                            <div class="circulClass"></div>
                            <div class="subtitleClass">报警统计</div>
                        </div>
                        <div class="lineClass"></div>
                        <div class="lodingClasss"><img src="../assets/homeimg/titleloading.gif" alt=""></div>
                    </div>
                    <div class="alarmContent">
                        <div class="alarmItem" @click="openDialog(2)">
                            <img src="../assets/homeimg/red.gif" alt="">
                            <span>{{ unDealtAlarm }}</span>
                            <div>未报警处理</div>
                        </div>
                        <div class="alarmItem">
                            <img src="../assets/homeimg/green.gif" alt="">
                            <span>{{ dealtAlarm }}</span>
                            <div>已报警处理</div>
                        </div>
                        <div class="alarmItem" @click="openDialog(3)">
                            <img src="../assets/homeimg/blue.gif" alt="">
                            <span>{{ alarmTotal }}</span>
                            <div>报警测点数</div>
                        </div>
                        <div class="alarmItem">
                            <img src="../assets/homeimg/blue.gif" alt="">
                            <span>{{ alarmDealRate }}%</span>
                            <div>报警处理率</div>
                        </div>

                    </div>
                </div>
                <div class="infoItem">
                    <div class="titleClass">
                        <div class="titleHead">
                            <div class="circulClass"></div>
                            <div class="subtitleClass">测点信息</div>
                        </div>
                        <div class="lineClass"></div>
                        <div class="lodingClasss"><img src="../assets/homeimg/titleloading.gif" alt=""></div>
                    </div>
                    <div class="rollContent"
                         @mouseleave="leave" @mousemove="move">
                        <dv-scroll-board :config="config" style="width:100%;height:100%"
                                         @mouseover="over"/>
                        <p
                            v-if="dvTextShow"
                            class="dv-text"
                            :style="{ top: dvText.keyY, left: dvText.keyX }"
                        >
                            {{ dvText.name }}
                        </p>
                    </div>
                </div>
            </div>
            <!--底部-->
            <img class="footerImg" src="../assets/homeimg/footer.png" alt="">
        </div>
        <!--    离线设备 -->
        <LinkDailog :linkVisible="linkVisible" :linkTitle="linkTitle" :linkList="linkList"
                    :linkNum="linkNum"></LinkDailog>
        <!-- 预览pdf -->
        <el-dialog
            id="preViewDialog"
            append-to-body
            title="预览文件"
            :visible.sync="previewPdf"
            width="70%"
            center
        >
            <iframe :src=pdfUrl frameborder="0" style="width:66vw; height: 70vh"></iframe>
        </el-dialog>

    </div>
</template>

<script>
import $ from "jquery"
import echarts from "echarts"
import LinkDailog from "./linkDailog";

export default {
    name: "ProjectChoose",
    components: {
        LinkDailog
    },
    data() {
        return {
            dataInfo: {},
            linkVisible: { show: false },
            linkTitle: "",
            linkList: [],
            linkNum: null,
            previewPdf: false,
            pdfUrl: "",
            map: null,
            realTime: "",
            timer1: "",
            timer2: "",
            // username:'',//用户名
            projectTitle: "",//顶部项目名称
            measureWork: {},//设备工作情况
            navListTitle: [],//顶部导航栏
            projectName: "",//设备统计 绑定值
            projectList: [],//设备统计 项目下拉
            tableList: [], // 设备统计 表格数据
            lastedDatas: [],//最新测点信息
            childrenArrId: [],//获取时间的
            config: {},
            time_date: "",
            time_hour: "",
            time_mimute: "",
            nowTime: "",
            zoomNum: null,
            centerArr: [],
            projectIdNum: "",
            mapCoordinateNum: "", //保存经纬度
            unDealtAlarm: 0,// 未处理
            dealtAlarm: 0,//已处理
            alarmTotal: 0,//报警总数
            alarmDealRate: 0,//报警处理率
            runTime: "",
            runTimeInterval: null,
            projectStartTime: "",
            indexLeftBottomData: [],
            alarmData: {},
            dvTextShow: false,
            dvText: {
                name: "",
                keyY: "",
                keyX: "",
            },
            getRightBottomTimeInterval: "",
            systemAbout: {
                descriptionArr: [
                    {
                        "type": "text",
                        "keyName": "名称",
                        "value": "智慧监测系统",
                        "images": [{ "url": "", "pdfUrl": "" }]
                    }, {
                        "type": "text",
                        "keyName": "型号",
                        "value": "SC-IOT",
                        "images": [{ "url": "", "pdfUrl": "" }]
                    }, {
                        "type": "text",
                        "keyName": "版本号",
                        "value": "SCIT.2022.12",
                        "images": [{ "url": "", "pdfUrl": "" }]
                    }, {
                        "type": "images",
                        "keyName": "",
                        "value": "",
                        "images": [{
                            "url": "http://resources.scentralit.com:24777/scit/monitor/standard/%E8%BE%B9%E5%9D%A1%E5%9C%A8%E7%BA%BF%E7%9B%91%E6%B5%8B%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F.png",
                            "pdfUrl": "http://resources.scentralit.com:24777/scit/monitor/standard/%E8%BE%B9%E5%9D%A1%E5%9C%A8%E7%BA%BF%E7%9B%91%E6%B5%8B%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F.pdf"
                        }, {
                            "url": "http://resources.scentralit.com:24777/scit/monitor/standard/%E5%9F%BA%E5%9D%91%E5%9C%A8%E7%BA%BF%E7%9B%91%E6%B5%8B%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F.png",
                            "pdfUrl": "http://resources.scentralit.com:24777/scit/monitor/standard/%E5%9F%BA%E5%9D%91%E5%9C%A8%E7%BA%BF%E7%9B%91%E6%B5%8B%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F.pdf"
                        }, {
                            "url": "http://resources.scentralit.com:24777/scit/monitor/standard/%E5%B9%BF%E5%9F%9F%E9%A2%84%E5%BA%94%E5%8A%9B%E6%B7%B7%E5%87%9D%E5%9C%9F%E6%A1%A5%E6%A2%81%E5%81%A5%E5%BA%B7%E8%BF%9C%E7%A8%8B%E7%9B%91%E6%B5%8B%E7%B3%BB%E7%BB%9F.jpg",
                            "pdfUrl": "http://resources.scentralit.com:24777/scit/monitor/standard/%E5%B9%BF%E5%9F%9F%E9%A2%84%E5%BA%94%E5%8A%9B%E6%B7%B7%E5%87%9D%E5%9C%9F%E6%A1%A5%E6%A2%81%E5%81%A5%E5%BA%B7%E8%BF%9C%E7%A8%8B%E7%9B%91%E6%B5%8B%E7%B3%BB%E7%BB%9F.pdf"
                        }]
                    }, {
                        "type": "text",
                        "keyName": "公司名称",
                        "value": "四川升拓检测技术股份有限公司",
                        "images": [{ "url": "", "pdfUrl": "" }]
                    }, {
                        "type": "text",
                        "keyName": "公司网站",
                        "value": "www.scentralit.com",
                        "images": [{ "url": "", "pdfUrl": "" }]
                    }, {
                        "type": "text",
                        "keyName": "联系方式",
                        "value": "028-68611520",
                        "images": [{ "url": "", "pdfUrl": "" }]
                    }
                ],
                "logoUrl": require("../assets/newimg/logo.png"),
                "bottomText": "四川升拓检测软件版权所有,保留所有权利"
            }
        }
    },
    computed: {
        username() {
            let username = localStorage.getItem("username");
            return username;
        }
    },
    mounted: function() {
        // this.getPreAlarmRecord()
        var docEl = document.documentElement;

        function reSetRem() {
            let w = docEl.clientWidth;
            var radio = w / 1920;//这里值设置成设计稿对应的屏幕宽度
            var rem = radio * 100 //值为初始化root font-size
            docEl.style.fontSize = rem + "px"
        }

        window.addEventListener("resize", reSetRem);
        reSetRem();
        //绘制地图背景色

        this.getProjectMainInfo()
        this.getData()
        let pieChart1 = echarts.init(document.getElementById("equipEchart"));
        window.onresize = function() {
            pieChart1.resize();
        }
        // 页面加载完后显示当前时间
        // this.realTime = this.dealWithTime(new Date());
        // 声明一个变量指向vue实例this,保证作用域一致
        // let _this = this;
        // _this.timer1 = setInterval(function () {
        //     _this.getRunData(_this.navListTitle)
        // }, 1000 * 60 * 60 * 24)

    },
    beforeDestroy() {
        clearInterval(this.runTimeInterval)
        clearInterval(this.getRightBottomTimeInterval)
    },
    methods: {
        clickMonitorList(row, column, event) {
            console.log(row, column, event)
            if (row.groupByProjectId === -1) {
                return
            } else {
                this.setFoundation(row.groupByProjectId, row.monitorObjNo)
            }
        },
        over(v) {
            this.dvTextShow = true
            //v.ceil拿到单元格数据
            this.dvText.name = v.row.join(" ")
            //没有值则直接隐藏悬浮框 不然如果设置padding会有背景
            if (this.dvText.name === undefined) {
                this.dvTextShow = false
            }
        },
        // 鼠标移动
        move(e) {
            //将获取的值x轴、y轴的值给悬浮框 用来定位到单元格上.
            //-1200 -500凭自己感觉调 因为每个表格在页面的位置都不一样
            // this.dvText.keyX = e.pageX - 1500 + 'px'
            // this.dvText.keyY = e.pageY - 660 + 'px'
        },
        // 鼠标离开
        leave() {
            //隐藏单元格
            this.dvTextShow = false
        },
        getProjectMainInfo() {
            // this.$axios.get("/api/monitor/index/index")
            this.$axios.get("/api/monitor/index/indexMainInfo").then(res => {
                let data = res.data
                if (data.datas) {
                    let datas = data.datas
                    if (datas.values) {
                        let values = datas.values

                        this.navListTitle = values.childProjects.slice(0)

                        //经纬度 解析
                        this.projectIdNum = values.projectId
                        if (values.coordinate) {
                            let str = values.coordinate
                            this.zoomNum = str.split(",")[2]
                            this.centerArr = [Number(str.split(",")[0]), Number(str.split(",")[1])]
                        } else {
                            this.zoomNum = 4
                            this.centerArr = [105, 36.719192]
                        }

                        this.drawMap()
                        this.map.on("zoomchange", this.mapZoom);
                        values.childProjects.forEach(item => {
                            this.childrenArrId.push(item.id)
                        })
                        this.projectList = values.childProjects
                        this.projectList.unshift({ id: "", name: "所有项目", measureList: [] })

                        this.projectTitle = values.projectMainName
                        localStorage.setItem("projectTitle", this.projectTitle)
                        localStorage.setItem("websocketUrl", values.websocketUrl)
                        this.projectStartTime = values.startTime
                        this.getRunTime()
                        this.runTimeInterval = setInterval(() => {
                            this.getRunTime()
                        }, 1000)
                    }
                }
            })
        },
        getRunTime() {
            let nowTime = new Date().getTime()
            let projectStartTime = new Date(this.projectStartTime).getTime()
            let runTime = nowTime - projectStartTime
            let day = Math.floor(runTime / (24 * 3600 * 1000))
            let leave1 = runTime % (24 * 3600 * 1000)
            let hours = Math.floor(leave1 / (3600 * 1000))
            let leave2 = leave1 % (3600 * 1000)
            let minutes = Math.floor(leave2 / (60 * 1000))
            let leave3 = leave2 % (60 * 1000)
            let seconds = Math.round(leave3 / 1000)
            this.runTime = day + "天" + hours + "小时" + minutes + "分" + seconds + "秒"
        },
        drawMap() {
            var SOC = "CHN"
            var colors = {};
            var GDPSpeed = {
                "520000": 10,//贵州
                "540000": 10,//西藏
                "530000": 8.5,//云南
                "500000": 8.5,//重庆
                "360000": 8.5,//江西
                "340000": 8.0,//安徽
                "510000": 7.5,//四川
                "350000": 8.5,//福建
                "430000": 8.0,//湖南
                "420000": 7.5, //湖北
                "410000": 7.5,//河南
                "330000": 7.0,//浙江
                "640000": 7.5,//宁夏
                "650000": 7.0,//新疆
                "440000": 7.0,//广东
                "370000": 7.0,//山东
                "450000": 7.3,//广西
                "630000": 7.0,//青海
                "320000": 7.0,//江苏
                "140000": 6.5,//山西
                "460000": 7,// 海南
                "310000": 6.5,//上海
                "110000": 6.5, // 北京
                "130000": 6.5, // 河北
                "230000": 6, // 黑龙江
                "220000": 6,// 吉林
                "210000": 6.5, //辽宁
                "150000": 6.5,//内蒙古
                "120000": 5,// 天津
                "620000": 6,// 甘肃
                "610000": 8.5,// 甘肃
                "710000": 2.64, //台湾
                "810000": 3.0, //香港
                "820000": 4.7 //澳门

            }

            var getColorByDGP = function(adcode) {
                if (!colors[adcode]) {
                    var gdp = GDPSpeed[adcode];
                    if (!gdp) {
                        colors[adcode] = "rgb(227,227,227)"
                    } else {
                        var r = 104;
                        var g = 154;
                        var b = 205;
                        var a = gdp / 9;
                        colors[adcode] = "rgba(" + r + "," + g + "," + b + "," + a + ")";
                    }
                }
                return colors[adcode]
            }

            var color = "rgba(6,101,200,0.5)";//rgba
            var disCountry = new AMap.DistrictLayer.Country({
                zIndex: 10,
                SOC: "CHN",
                depth: 20,
                styles: {
                    "nation-stroke": "#22ffff",
                    "province-stroke": "#ffffff",
                    "fill": function(props) {//中国特有字段
                        return color
                    },
                }
            })
            var map = new AMap.Map("container", {
                pitch: 0,			//修改地图的初始俯仰角度，俯仰角的有效范围为0度－83度。
                resizeEnable: true,
                zooms: [3, 20],
                center: this.centerArr,
                zoom: this.zoomNum,
                mapStyle: "amap://styles/68e2ea799a0fcfe6814cbd8f725a8e05",
                // isHotspot:false,
                disableSocket: true,
                viewMode: "3D",
                showLabel: true,
                labelzIndex: 130,
                features: ["bg", "building", "point"],
                defaultCursor: "pointer",
                layers: [
                    // disCountry
                ],
            })
            this.map = map;
            var object3Dlayer = new AMap.Object3DLayer({ zIndex: 0 });
            this.map.add(object3Dlayer);
            var opts = {
                subdistrict: 0,   //返回下一级行政区
                extensions: "all",  //返回行政区边界坐标组等具体信息
                level: "city"  //查询行政级别为 市  //返回行政区边界坐标组等具体信息
            };

            //利用行政区查询获取边界
            var district = new AMap.DistrictSearch(opts);
            district.search("中国", function(status, result) {
                var bounds = result.districtList[0].boundaries;
                var height = 999999;
                var color = "rgba(60,162,214,0.85)";//rgba
                var wall = new AMap.Object3D.Wall({
                    path: bounds,
                    height: height,
                    color: color
                });
                wall.backOrFront = "both";
                wall.transparent = true;
                object3Dlayer.add(wall);
            });
            // this.map.addControl(new AMap.Scale());
            this.map.addControl(new AMap.ToolBar({ liteStyle: true }));
            this.map.on("complete", function() {
                var layer = new AMap.LabelsLayer({
                    // 开启标注避让，默认为开启，v1.4.15 新增属性
                    collision: false,
                    // 开启标注淡入动画，默认为开启，v1.4.15 新增属性
                    animation: true,
                });
                for (var i = 0; i < LabelsData.length; i++) {
                    var labelsMarker = new AMap.LabelMarker(LabelsData[i]);
                    layer.add(labelsMarker);
                }
                map.add(layer);
            })      //添加描边
            this.navListTitle.forEach(item => {
                let icon = new AMap.Icon({
                    size: new AMap.Size(40, 40),    // 图标尺寸
                    image: require("../assets/mark/mark.png"),  // Icon的图像
                    imageSize: new AMap.Size(40, 40)   // 根据所设置的大小拉伸或压缩图片
                });
                let markerContent = "" +
                    "<div class=\"custom-content-marker\">" +
                    "<img src=\" " + require("../assets/mark/mark.png") + "\">" +
                    "</div>"
                let marker = null
                if (item.coordinate) {
                    marker = new AMap.Marker({
                        position: new AMap.LngLat(item.coordinate.split(",")[0],
                            item.coordinate.split(",")[1]),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                        offset: new AMap.Pixel(-30, -80),
                        content: markerContent
                    })
                }
                //信息窗口内容设置
                let content = "<div style='padding: 0.02rem 0.1rem'>" +
                    "<div style='font-weight: bold;font-size: 16px'>" + item.name + "</div>" +
                    "<div style='font-size: 14px'>" + item.description + "</div>" + "</div>"
                //信息窗口设置
                let infoWindow = new AMap.InfoWindow({
                    anchor: "bottom-right",
                    content: content,
                    offset: new AMap.Pixel(-20, -5)
                });
                if (marker) {
                    marker.on("dblclick", () => {
                        if (item.id) {
                            this.setFoundation(item.id)
                        }
                    })
                    marker.on("click", () => {
                        infoWindow.open(this.map, [item.coordinate.split(",")[0], item.coordinate.split(",")[1]]);
                    })
                    //延迟2s关闭窗口
                    this.map.add(marker);
                }
            })
        },
        //获取缩放比例
        mapZoom() {
            let info = this.navListTitle[0]
            this.zoomNum = this.map.getZoom(); //获取当前地图级别
            if (Number(this.zoomNum) < 5) {
                this.centerArr = [105, 36.719192]
                this.mapCoordinateNum = "105,36.719192," + this.zoomNum
            } else {
                this.centerArr = [info.coordinate.split(",")[0], info.coordinate.split(",")[1]]
                this.mapCoordinateNum = info.coordinate.split(",")[0] + "," + info.coordinate.split(",")[1] + "," + this.zoomNum
            }
            this.map.setZoomAndCenter(this.zoomNum, this.centerArr);
        },
        // getPreAlarmRecord(){
        //     this.$axios.get('/api/monitor/dataHistory/getPreAlarmRecord?version=3').then(res=>{
        //         if(res.data.status == 200){
        //
        //
        //         }else{}
        //     })
        // },

        getRunData(title) {
            let arr = title
            let Str = []
            arr.forEach(item => {
                Str.push(item.id)
            })
            this.$axios.get("api/monitor/index/getRunTime?childProjectIds=" + Str.toString()).then(res => {
                if (res.data.status == 200) {
                    let timeStr = res.data.datas.values;
                    if (timeStr !== "") {
                        let _this = this;
                        _this.time_date = timeStr.split("天")[0];
                        // console.log(_this.time_date,666)
                        _this.timer2 = setInterval(function() {
                            _this.realTime = _this.dealWithTime(new Date()) // 修改数据date
                        }, 1000)

                    } else {
                        this.time_date = "0"
                        this.time_hour = "00"
                        this.time_mimute = "00"
                        this.nowTime = "00"
                    }
                }
                return
            })
        },
        /*获取当前时间*/
        dealWithTime(timeStamp) {
            let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
            let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
            let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
            this.time_hour = hh
            this.time_mimute = mm
            this.nowTime = ss
        },
        //加载页面，获取数据
        getData() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.9)"
            });
            this.getAboutUs()
            this.indexLeftTop(loading)
            this.indexLeftBottom(loading)
            this.indexRightTop(loading)
            this.indexRightBottom(loading)
            this.getRightBottomTimeInterval = setInterval(() => {
                this.indexRightBottom(loading)
            }, 30 * 1000)
        },
        getAboutUs() {
            this.$axios.get("api/monitor/index/systemAbout").then(res => {
                if (res.data.datas) {
                    if (res.data.datas.values) {
                        if (res.data.datas.values.systemAbout) {
                            let obj = JSON.parse(res.data.datas.values.systemAbout)
                            this.systemAbout = obj
                        }
                    }
                }
            })
        },
        indexLeftTop(loading) {
            this.$axios.get("api/monitor/index/deviceOnlineInfo").then(res => {
                this.measureWork = {}
                this.measureWork = res.data.datas.values
                setTimeout(() => {
                    this.getEchart()
                }, 800)
                loading.close();
            }).catch(() => {
                loading.close();
            })
        },
        indexLeftBottom(loading) {
            this.$axios.get("api/monitor/index/projectCountInfo").then(res => {
                let values = res.data.datas.values
                this.indexLeftBottomData = values
                this.indexLeftBottomData.forEach(data1 => {
                    data1.monitorObjList.forEach(data2 => {
                        data2.groupByProjectId = data1.childProjectId
                    })
                })
                this.tableList = this.indexLeftBottomData[0].monitorObjList
                loading.close();
            }).catch(() => {
                loading.close();
            })
        },
        indexRightTop(loading) {
            this.$axios.get("api/monitor/index/alarmInfo").then(res => {
                let values = res.data.datas.values
                this.alarmData = values
                this.unDealtAlarm = values.unDealtAlarm
                this.dealtAlarm = values.dealtAlarm
                this.alarmTotal = values.alarmTotal
                if (values.alarmDealRate) {
                    this.alarmDealRate = values.alarmDealRate
                }
                loading.close();
            }).catch(() => {
                loading.close();
            })
        },
        indexRightBottom(loading) {
            this.$axios.get("api/monitor/index/recentDataInfo").then(res => {
                this.lastedDatas = res.data.datas.values

                this.config = {
                    header: ["监测结构", "监测参数", "数据显示", "时间"],
                    align: ["center", "center", "center", "center"],
                    waitTime: 1000,
                    // columnWidth:[100,300,100],
                    data: [], headerBGC: "", oddRowBGC: "#132638", evenRowBGC: "#132638"
                }
                this.lastedDatas.forEach(item => {
                    let str = item.dataJson
                    let last = str.substr(0, str.length - 1)
                    let first = last.slice(1)
                    if (first.indexOf(",") == -1) {
                        item.dataJson = [Number(first).toFixed(3)]
                    } else {
                        item.dataJson = [Number(first.split(",")[0]).toFixed(3), Number(first.split(",")[1]).toFixed(3)]
                    }
                })
                this.lastedDatas.forEach((item, index) => {
                    this.config.data.push([item.childProjectName, item.alias, item.dataJson, item.dataTime])
                })
                loading.close();
            }).catch(() => {
                loading.close();
            })
        },

        //点击下拉
        selectProNo(e) {
            this.tableList = []
            if (e.id === "") {
                this.tableList = this.indexLeftBottomData[0].monitorObjList
            } else {
                this.indexLeftBottomData.forEach(data => {
                    if (data.childProjectId == e.id) {
                        this.tableList = data.monitorObjList
                    }
                })
            }
        },
        //Echarts
        getEchart() {
            let pieChart = echarts.init(document.getElementById("equipEchart"));
            let option = {
                grid: {
                    containLabel: true
                },
                legend: {
                    bottom: "0%",
                    right: "5%",
                    itemWidth: 10,
                    itemHeight: 10,
                    padding: [0, 0],
                    orient: "horizontal",
                    textStyle: {
                        color: "#ffffff"
                    },
                    formatter: function(name) {
                        return name;
                    }
                },
                color: ["#00C988", "#D8CA3D"],
                series: [
                    {
                        type: "pie",
                        radius: ["50%", "70%"],
                        avoidLabelOverlap: true,
                        label: {
                            // alignTo: 'edge',
                            formatter: "{name|{b}}:{value|{c}%}",
                            // minMargin: 20,
                            // edgeDistance:50,
                            // lineHeight: 20,
                            textStyle: { //数值样式
                                color: "#ffffff",
                                fontSize: 12
                            },
                            rich: {
                                time: {
                                    fontSize: 10,
                                    color: "#ffffff",
                                }
                            }
                        },
                        data: [
                            {
                                value:Number(100),
                                name: "设备在线率"
                            },
                            {
                                value: Number(0),
                                name: "设备离线率"
                            },
                        ]
                    }
                ]
            };
            pieChart.setOption(option, true)
        },
        // 点击项目跳转
        // 双击事件函数
        setFoundation(id, monitorObjNo) {
            if (id == null || id == 0) {
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.9)"
            });
            // return;
            this.$axios.get("/api/monitor/model/decision/systemType?id=" + id).then(res => {
                if (res.data.status === 200) {
                    let childProject = res.data.datas.values.childProject;
                    if (childProject != null) {
                        localStorage.setItem("mainId", childProject.id);
                        localStorage.setItem("systemType", childProject.systemType);
                        localStorage.setItem("url", "http://detect.scentralit.com:9095/image/");
                        if (childProject.systemType == "1") {//3D
                            localStorage.setItem("path", res.data.datas.values.bimViewToken)
                            localStorage.setItem("currentpoint", res.data.datas.values.childProject.childProjectType3d.modelView)
                            if (monitorObjNo) {
                                this.$router.push({ name: "realTimeData", query: { measurePart: monitorObjNo } });
                            } else {
                                this.$router.push({ name: "realTimeData" })
                            }
                        } else {
                            localStorage.setItem("path", childProject.childProjectType2d.projectPicPath);
                            if (monitorObjNo) {
                                this.$router.push({ name: "realTimeData2d", measurePart: monitorObjNo });
                            } else {
                                this.$router.push({ name: "realTimeData2d" })
                            }
                        }
                    }
                    loading.close();
                } else {
                    loading.close();
                }

            }).catch(() => {
                loading.close();
            })
            // clearTimeout(time);
        },
        // 点击保存projectIdNum
        saveMap() {
            let req = {
                id: this.projectIdNum,
                mapCoordinate: this.mapCoordinateNum
            }
            this.$axios.post("api/monitor/index/saveMapLocation", req).then(res => {
                if (res.data.status == 200) {
                    this.$message.success("保存成功")
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        //退出
        logout() {
            this.$axios.get("/api/auth/auth/logout ").then(res => {
                let projectCode = localStorage.getItem("projectCode");
                localStorage.clear();
                if (projectCode) {
                    this.$router.replace({ path: "/", query: { projectCode: projectCode } })
                } else {
                    this.$router.replace({ path: "/" });
                }
            })
        },
        //    点击离线设备
        openDialog(num) {
            this.linkNum = num
            if (num === 1) {
                this.linkTitle = "离线设备测点",
                    this.linkList = this.measureWork.stops,
                    this.linkVisible.show = true
            }
            if (num === 2) {
                this.linkTitle = "未报警处理",
                    this.linkList = this.alarmData.undealtAlarms,
                    this.linkVisible.show = true
            }
            if (num === 3) {
                this.linkTitle = "报警测点数 ",
                    this.linkList = this.alarmData.alarms,
                    this.linkVisible.show = true
            }

        },
        //    点击预览pdf
        openPdf(url) {
            this.pdfUrl = url
            this.previewPdf = true
        },
        openUrl(url) {
            if (this.isURL(url)) {
                window.open("//" + url, "_blank")
            }
        },
        isURL(input) {
            let urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:[\w-]+\.)+[a-z]{2,6}(?:\/[\w-]*)*(?:\?\S*)?$/i;
            return urlRegex.test(input);
        }

    },
    destroyed() {//页面关闭时监听
        let _this = this
        clearInterval(_this.timer1)
        clearInterval(_this.timer2)
    },
}
</script>

<style>
#container .amap-zoomcontrol {
    width: 28px;
}

#container .amap-zoom-touch-plus > div {
    line-height: 28px;
}

#container .amap-zoom-touch-minus > div {
    line-height: 28px;
}

#preViewDialog .el-dialog__header {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

#preViewDialog .el-dialog {
    background: rgba(6, 21, 43, 0.85);
}

#preViewDialog .el-dialog__header {
}

#preViewDialog .el-dialog__title {
    font-size: 18px;
    font-weight: 800;
    text-align: center;
    word-spacing: 5px;
    color: #FFFFFF !important;
}

#preViewDialog .el-dialog__headerbtn {
    background-color: #334560;
    padding: 2px 2px;
    color: #FFFFFF !important;
}

#preViewDialog .el-dialog__body {
    padding: 10px 10px !important;
}


.custom-content-marker > img {
    display: inline-block;
    width: 0.3rem !important;
    height: 0.3rem !important;
}

.cen-top .custom-content-marker {
    animation: myfirst 2s infinite !important;
}

@keyframes myfirst {
    0% {
        transform: translate(0rem, 0rem);
    }
    50% {
        transform: translate(0rem, 0.12rem);
    }
    100% {
        transform: translate(0rem, 0rem);
    }
}

#equipment .el-input__inner {
    background: transparent;
}

#equipment input {
    color: #ffffff;
}

#equipment .el-table .el-select-dropdown {
    background: #FFFFFF !important;
}

#equipment .el-select {
    width: 2rem;
    height: 0.2rem;
    float: right;
}

#equipment .el-table__cell {
    background-color: transparent;
}

#equipment .el-table, .el-table__expanded-cell {
    background-color: transparent;
}

#equipment .el-table th, .el-table tr {
    background-color: transparent !important;
}

#equipment .el-table--fit {
    position: inherit;
    padding: 0 0.2rem;
}

#equipment .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #6d9dd2;
}

#equipment .el-table {
    color: #FFF;
}

#equipment .el-table thead {
    color: #FFF;
}

#equipment::-webkit-scrollbar {
    visibility: hidden;
}

.el-popper[x-placement^=top] .popper__arrow::after {
    border-top-color: #1574CD;
}

.el-popper[x-placement^=top] .popper__arrow {
    border-top-color: #1574CD;
}

.el-popper[x-placement^=bottom] .popper__arrow::after {
    border-bottom-color: #1574CD;
}

.el-popper[x-placement^=bottom] .popper__arrow {
    border-bottom-color: #1574CD;
}

.popover.el-popover {
    background: rgba(6, 21, 43, 0.85);
    border-color: #1574CD;
    /*opacity: 0.92;*/
    color: #fff;
}

.rollContent {
    position: relative;
}

.dv-text {
    background: #333;
    padding: 10px !important;
    font-size: 14px;
    z-index: 11;
    color: #fff;
    position: absolute;
    left: 0;
    top: 0;
}

.el-select-dropdown__item {
    text-align: center;
}

</style>
<style scoped>
@import '../assets/css/home.css';
</style>



// WEBPACK FOOTER //
// src/components/ProjectChoose.vue